import { Content } from "./styles";

export function Footer() {
  return (
    <Content>
      <p>&copy; Copyright Ping. All rights reserved.</p>
      <div>
        <p>
          Challenge by{" "}
          <a
            href="https://www.frontendmentor.io?ref=challenge"
            target="_blank"
            rel="noreferrer"
          >
            Frontend Mentor
          </a>
          .
        </p>

        <p>
          Coded by{" "}
          <a
            href="https://github.com/augustomoscardo"
            target="_blank"
            rel="noreferrer"
          >
            Augusto Moscardo
          </a>
          .
        </p>
      </div>
    </Content>
  );
}
